import { useCallback } from "react";
import { TimeEditTarget, useTimeModal } from "../context/TimeModalContext";

type OpenTimeModalOptions = {
    openOnTop?: boolean;
};

const useTimeModalActions = () => {
    const { open, setOpenOnTop, setTimeTarget } = useTimeModal();

    const openTimeModal = useCallback(
        (target: TimeEditTarget, options?: OpenTimeModalOptions) => {
            if (options?.openOnTop) {
                setOpenOnTop(true);
            }
            setTimeTarget(target);
            open();
        },
        [open, setOpenOnTop, setTimeTarget]
    );

    return { openTimeModal };
};

export default useTimeModalActions;
